<template>
  <div>
    <div>
      <h1 class="title">{{ $t('common.posts') }}</h1>
      <p class="subtitle is-5">ServiceID: {{ serviceId }}</p>

      <div
        v-if="outerSiteUrl"
        class="is-pulled-right"
      >
        <a
          :href="outerSiteUrl"
          target="_blank"
        >
          <i class="fas fa-globe-asia"></i>
          <span>{{ $t('common.webSite') }}</span>
        </a>
      </div>

      <router-link
        v-if="hasEditorRole"
        :to="{ path: `/admin/posts/${this.serviceId}/create`, query: { category: categoryQuery } }"
        class="button"
        >{{ $t('common.createNew') }}</router-link
      >
    </div>
    <post-list
      class="mt-6"
      :is-admin="true"
    ></post-list>
  </div>
</template>
<script>
import { Admin } from '@/api'
import common from '@/util/common'
// import AdminPostList from '@/components/organisms/AdminPostList'
import PostList from '@/components/organisms/PostList'

export default {
  name: 'AdminPosts',

  components: {
    PostList,
  },

  data() {
    return {
      service: null,
    }
  },

  computed: {
    outerSiteUrl() {
      if (this.service == null) return ''
      if (common.checkObjHasProp(this.service, 'configs') === false) return ''
      if (common.checkObjHasProp(this.service.configs, 'outerSiteUrl') === false) return ''
      return this.service.configs.outerSiteUrl
    },

    categoryQuery() {
      const defaultValue = ''
      if (!this.$route.query.category) return defaultValue
      return this.$route.query.category
    },
  },

  async created() {
    await this.setService()
  },

  methods: {
    async setService() {
      this.service = await Admin.getServices(this.serviceId, null, this.adminUserToken)
    },
  },
}
</script>
